import React from "react";
import { MediaBaseUrl } from "../../../../actions/api";
export const ThankYouStartUp = () => {
    return <>
        <div className="d-flex flex-column flex-root">

            <div className="d-flex flex-column-fluid page">

                <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">

                    <div className="content  d-flex flex-column flex-column-fluid" id="kt_content">
                        <div className="controller" id="accounts">
                            <div className="action" id="accountsthankYouStartUp">
                                <div className="d-flex flex-column flex-root" style={{ minHeight: 'calc(100vh - 65px)' }}>

                                    <div className="d-flex flex-row-fluid">

                                        <div className="small_container d-flex flex-row-fluid flex-column justify-content-center p-5 text-center">
                                            <div className="upgrade_succ_wrap p-5 position-relative f-center active">
                                                <div className="upgrade_succ">
                                                    <img src={`${MediaBaseUrl}success/upgrade-account-bg.svg`} className="img-fluid" alt="" />
                                                </div>
                                                <img src={`${MediaBaseUrl}success/Upgrade-Account.svg`} className="img-fluid position-relative" alt="" />
                                            </div>
                                            <h2 className="font-weight-boldest mb-3 display-4">Congratulations 🎉 🎉</h2>
                                            <p className="font-size-h6">You have successfully upgraded to <span className="text-gradient font-weight-boldest">StartUp plan</span>.</p>
                                            <p className="font-size-h6">Explore new possibilities &amp; features now</p>
                                            <div className="mt-3">
                                                <a href="/widget/walls/home" className="btn btn-primary btn-lg btn-min-w">Explore Now</a> </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </>
};

